var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0002 0.00109863C5.78722 0.00109863 0.750488 5.03783 0.750488 11.2508C0.750488 16.8231 4.80623 21.4379 10.124 22.3315V13.5978H7.41021V10.4549H10.124V8.1374C10.124 5.44847 11.7663 3.98316 14.1653 3.98316C15.3143 3.98316 16.3018 4.06878 16.5884 4.10649V6.91714L14.9245 6.91794C13.6201 6.91794 13.3686 7.53767 13.3686 8.4474V10.4533H16.4811L16.0751 13.5962H13.3686V22.4067C18.9346 21.7293 23.2498 16.9969 23.2498 11.2476C23.2498 5.03783 18.213 0.00109863 12.0002 0.00109863Z","fill":"white"}));
}

FacebookInline.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
